import styled from "styled-components/macro";
import { Text } from "@gcs/design-system/react";
import { ReactComponent as DownloadIconWebp } from "assets/svgs/download-icon.svg";

export const ItemLine = styled(Text)(({ theme }) => ({
  paddingTop: "64px",
  borderBottom: `1px solid ${theme.color.neutral["04"]}`,
  margin: "0px",
}));

export const Grid = styled.section(({ theme }) => ({
  display: "grid",
  margin: "0 16px",

  [theme.breakpoint.md()]: {
    margin: "0 24px",
  },

  [theme.breakpoint.lg()]: {
    margin: "0 56px",
  },

  [theme.breakpoint.xl()]: {
    margin: "0 calc((100% - 1560px)/2)",
  },

  "@media (min-width: 1200px) and (max-width: 1600px)": {
    margin: "0 112px",
  },

  [theme.breakpoint.md()]: {
    gridTemplateColumns: "repeat(1, 1fr)",
  },
}));

export const GridContainer = styled.div(({ theme }) => ({
  display: "grid",
  gap: "10px",
  margin: "0px 300px 0px 250px",
  borderBottom: `1px solid ${theme.color.neutral["04"]}`,
  alignItems: "baseline",

  [theme.breakpoint.xs()]: {
    margin: "0px 0px 44px 0px",
  },

  [theme.breakpoint.xl()]: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },

  ":last-child": {
    borderBottom: "none"
  }
}));

export const GridItem = styled.div(({ theme }) => ({
  rowGap: "10px",
  padding: "0px 16px",
  textAlign: "start",
  borderBottom: `1px solid ${theme.color.neutral["04"]}`,

  [theme.breakpoint.lg()]: {
    padding: "0px",
  },

  ":nth-child(odd)": {
    borderBottom: "none"
  },
  ":nth-last-child(2)": {
    borderBottom: "none !important",
  }
}));

export const TitleTopic = styled(Text)(({ theme }) => ({
  fontSize: "28px",
  fontWeight: "700",
  lineHeight: "150%",
  color: theme.color.neutral["02"],

  [theme.breakpoint.xl()]: {
    fontSize: "32px",
  },
}));

export const TitleItem = styled(Text)(({ theme }) => ({
  fontSize: "24px",
  fontWeight: "700",
  lineHeight: "150%",

  marginBottom: "20px",
  marginTop: "40px",

  [theme.breakpoint.lg()]: {
    marginTop: "64px"
  },
}));

export const Description = styled(Text)(({ theme }) => ({
  fontSize: "18px",
  fontWeight: "32px",
  lineHeight: "160%",

  marginBottom: "34px",

  [theme.breakpoint.xl()]: {
    fontSize: "20px",
  },
}));

export const DownloadIcon = styled(DownloadIconWebp)(({ theme, isMobile }) => ({
  marginRight: "20px",
  color: "#D70064",

  "@media (max-width: 768px)": {
    display: "none",
  },
}));

export const LinkDownload = styled.a(({ theme }) => ({
  fontSize: "16px",
  color: "#D70064",
  fontWeight: "700",
  lineHeight: "24px",
  textDecoration: "none",
  display: "inline-block",
  height: "fit-content",
  marginBottom: "44px",

  [theme.breakpoint.xs()]: {
    fontSize: "14px",
    lineHeight: "21px",
  },

  [theme.breakpoint.md()]: {
    fontSize: "16px",
    lineHeight: "24px",
  },

  [theme.breakpoint.lg()]: {
    marginBottom: "64px",
  },

  "@media (max-width: 768px)": {
    border: "1px solid #D70064",
    borderRadius: "10px",
    padding: "16px 36px",
    color: "#D70064",
    fontWeight: 800,

    textDecoration: "none",
    ":hover": {
      backgroundColor: "#D70064",
      color: "#fff",
    },
  },
}));
